export default __webpack_public_path__ + "static/media/sub-app-bill-split-logo.2dafffd27037bfb30f4b1d527b44a92c.webp";